module.exports = __webpack_public_path__ + "static/media/constPicOne.435b6f87.jpeg";